import actionCreatorFactory from "typescript-fsa";
import { RecaptchaCheckRequestBody } from "../../core/api/requests/recaptcha/check/types";
import { TwilioCheckRequestBody } from "../../core/api/requests/twilio/check/types";
import { TwilioSendRequestBody } from "../../core/api/requests/twilio/send/types";
import { CommonAsyncType } from "../../core/types";

const actionCreator = actionCreatorFactory("@@External");

export const externalActions = {
  checkRecaptcha: actionCreator.async<CommonAsyncType<boolean> & RecaptchaCheckRequestBody, boolean>("CHECK_RECAPTCHA"),
  checkTwilioCode: actionCreator.async<CommonAsyncType<boolean> & TwilioCheckRequestBody, boolean>("CHECK_TWILIO_CODE"),
  sendTwilioCode: actionCreator.async<CommonAsyncType & TwilioSendRequestBody, {}>("SEND_TWILIO_CODE"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
